import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { themeNames } from '../../common/utils/api_utils';
import TooltipInfo from '../../common/docs/TooltipInfo';

export class GlobalTheme extends Component {
  static propTypes = {
    onBoarding: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedThemeName: null,
    savedThemeName: null,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    const { version, projectId } = match.params;
    actions.getGlobalTheme({ version, projectId });
  }

  componentDidUpdate(prevProps) {
    const { onBoarding } = this.props;
    if (prevProps.onBoarding !== onBoarding) {
      const selectedThemeName = this.getSelectedThemeName();
      if (selectedThemeName && selectedThemeName !== this.state.savedThemeName) {
        this.setState({ selectedThemeName, savedThemeName: selectedThemeName });
      }
    }
  }

  handleCardClick = (themeName) => {
    this.setState({ selectedThemeName: themeName });
  };

  handleSaveAndNext = async () => {
    const { actions, match, history,location } = this.props;
    const { version, projectId } = match.params;
    const { selectedThemeName, savedThemeName } = this.state;
    const { state = {} } = location;
    const { userPrompt, roles, AiProject } = state;
    if (selectedThemeName) {
      const globalThemeData = {
        urlOrTag: `${process.env.REACT_APP_S3_STATIC_URL}global-theme/bootstrap5/${selectedThemeName}/bootstrap.min.css`,
        customType: 'GLOBAL_THEME',
        loadToBuilder: true,
        globalThemeName: selectedThemeName,
      };

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to add this theme to your project and proceed to the next step?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, save and next!',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        const res = await actions.addGlobalThemes({ version, projectId, globalThemeData });
        if (res.status === 201) {
           if(!AiProject){
          history.push(`/on-boarding/${version}/v/${projectId}/summary`);
           }else{
            history.push({
              pathname: `/ai-prompt-builder/${version}/v/${projectId}/prompt-pages-list`,
              state: { userPrompt, roles:roles },
            });
           }
        }
      } else if (result.isDismissed) {
        this.setState({ selectedThemeName: savedThemeName });
      }
    } else {
      toast.error('No theme selected');
    }
  };

  handleSkipAndNext = () => {
    const { match,location,history} = this.props;
    const { version, projectId } = match.params;
    const { state = {} } = location;
    const { userPrompt, roles, AiProject } = state;
    if(!AiProject){
      history.push(`/on-boarding/${version}/v/${projectId}/summary`);
  }else{
    history.push({
      pathname: `/ai-prompt-builder/${version}/v/${projectId}/prompt-pages-list`,
      state: { userPrompt, roles: roles },
    });
  }
  }

  getSelectedThemeName = () => {
    const { onBoarding } = this.props;
    const { globalTheme } = onBoarding;
    if (globalTheme && globalTheme.length > 0) {
      const selectedTheme = globalTheme.find((theme) => theme.customType === 'GLOBAL_THEME');
      return selectedTheme ? selectedTheme.globalThemeName : null;
    }
    return null;
  };

  render() {
    const { selectedThemeName } = this.state;
    const { match, addGlobalThemesPending } = this.props;
    const { version, projectId } = match.params;
    return (
      <CommonPageComponent>
        <ParentContentCard title={'Choose Project Look & Feel'} icon={'drapcode-icons'}>
          <div className="container-fluid">
            <h5 style={{ textTransform: 'none' }}>
              It will apply a predefined Ul theme across an application, standardizing the
              appearance of elements like buttons, links, text colors, and fonts for a consistent
              and cohesive design.
            </h5>

            <div className="row show_scrollbar" style={{ height: '48vh', overflow: 'auto' }}>
              {themeNames.map((themeName) => (
                <div
                  className={`col-md-3 ${
                    selectedThemeName === themeName ? 'border-2 border-success' : ''
                  }`}
                  key={themeName}
                >
                  <div
                    className="card"
                    onClick={() => this.handleCardClick(themeName)}
                    style={{ cursor: 'pointer', borderRadius: '0.25rem', overflow: 'hidden' }}
                  >
                    {selectedThemeName === themeName && (
                      <div
                        className="position-absolute"
                        style={{
                          top: '3px',
                          left: '3px',
                          color: 'green',
                          fontSize: '18px',
                          zIndex: 1,
                          borderRadius: '50%',
                        }}
                      >
                        <i className="fas fa-check-circle"></i>
                      </div>
                    )}
                    <TooltipInfo
                      title={`Preview <b>${themeName}</b> theme`}
                      headerText={``}
                      showHeader={false}
                      showArrow={true}
                      key={themeName}
                    >
                      <button
                        className="btn btn-theme-submit mr-2 btn-xs ml-1 position-absolute"
                        style={{
                          right: '0px',
                        }}
                        onClick={() => window.open(`https://bootswatch.com/${themeName}`, '_blank')}
                      >
                        <i className="wb  webconnect-arrow-up-right-circle-fill"></i>
                      </button>
                    </TooltipInfo>
                    <img
                      src={`${process.env.REACT_APP_S3_STATIC_URL}global-theme/bootstrap5/${themeName}/thumbnail.png`}
                      className="card-img-top"
                      alt={`Theme ${themeName}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </ParentContentCard>
        <div className="col-12 mt-0">
          <div className="container1">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right d-flex justify-content-between">
              <button
                className="btn btn-outline-primary btn-md mr-4"
                onClick={this.handleSkipAndNext}
                title={'Go to Next Step'}
              >
                <i className="wb webconnect-skip-forward-fill"></i>
                &nbsp;Skip to next step
              </button>

              <button
                className={
                  selectedThemeName === null
                    ? 'btn btn-default btn-md'
                    : 'btn btn-theme-submit btn-md'
                }
                onClick={this.handleSaveAndNext}
                title={'Save & Go to Next Step'}
                disabled={addGlobalThemesPending || selectedThemeName === null}
              >
                <i className="wb webconnect-save-regular"></i>&nbsp;Add & continue to next step
              </button>
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    onBoarding: state.onBoarding,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalTheme);
